import { getMenuRoutes } from "@/api/menu";

// 同一页面周期内复用菜单接口，避免 main / 路由守卫 / 首页各打一次
let menuRoutesRequest = null;

async function fetchMenuRoutes() {
  if (!menuRoutesRequest) {
    menuRoutesRequest = getMenuRoutes().catch((err) => {
      menuRoutesRequest = null;
      throw err;
    });
  }
  return menuRoutesRequest;
}

// 路径到组件的映射
const componentMap = {
  "/mobile/warein-putaway": () => import("@/view/wareIn/WareInPutaway.vue"),
  "/mobile/warein-receive": () => import("@/view/wareIn/WareInReceive.vue"),
  "/mobile/warein-receive/create": () =>
    import("@/view/wareIn/WareInReceiveCreate.vue"),
  "/mobile/warein-receive/multi-pallet": () =>
    import("@/view/wareIn/WareInReceiveMultiPallet.vue"),
  "/mobile/warein-putaway/detail": () =>
    import("@/view/wareIn/WareInPutawayDetail.vue"),
  "/mobile/warein-putaway/scan": () =>
    import("@/view/wareIn/WareInPutawayScan.vue"),
  "/mobile/pls-scan-stock-in": () => import("@/view/wareIn/PLSScanStockIn.vue"),
  "/mobile/scan-stock-in-new": () => import("@/view/wareIn/ScanStockInNew.vue"),
  "/mobile/pls-receive": () => import("@/view/wareIn/PLSReceive.vue"),
  "/mobile/tcl-scan-receive": () => import("@/view/wareIn/TclScanReceive.vue"),
  "/mobile/tcl-scan-out": () => import("@/view/wareOut/TclScanOut.vue"),
  "/mobile/wareout-list": () => import("@/view/wareOut/WareOutList.vue"),
  "/mobile/scan-wareout": () => import("@/view/wareOut/ScanWareOut.vue"),
  "/mobile/loading-order": () =>
    import("@/view/loadingOrder/LoadingOrderList.vue"),
  "/mobile/stock-transfer": () =>
    import("@/view/stockTransfer/StockTransfer.vue"),
  "/mobile/quality-transfer": () =>
    import("@/view/stockTransfer/QualityTransfer.vue"),
  "/mobile/material-stock-query": () =>
    import("@/view/stockQuery/MaterialStockQuery.vue"),
  "/mobile/project-team-stock-check": () =>
    import("@/view/stockCheck/ProjectTeamStockCheck.vue"),
  "/mobile/prepare-list": () =>
    import("@/view/materialPreparation/PrepareList.vue"),
  "/mobile/pls-material-preparation-mobile": () =>
    import("@/view/materialPreparation/PlsResourceNoScan.vue"),
  "/mobile/ware-location-check": () =>
    import("@/view/materialPreparation/WareLocationCheck.vue"),
  // 可以继续添加其他移动端路由映射
};

// 扁平化菜单树，提取所有移动端路由
function normalizeRouteName(code, path) {
  const base = `${code || "mobile"}_${path || ""}`;
  return base.replace(/[^A-Za-z0-9_]/g, "_");
}

function flattenMobileRoutes(menus, result = []) {
  menus.forEach((menu) => {
    // 只处理移动端权限下的路由
    if (menu.path && menu.path.startsWith("/mobile")) {
      result.push({
        path: menu.path,
        name: normalizeRouteName(menu.code, menu.path),
        meta: {
          title: menu.name,
          requiresAuth: true,
        },
        component: componentMap[menu.path] || null,
      });
    }

    // 递归处理子菜单
    if (menu.children && menu.children.length > 0) {
      flattenMobileRoutes(menu.children, result);
    }
  });
  return result;
}

// 动态添加路由
export async function addDynamicRoutes() {
  try {
    const response = await fetchMenuRoutes();
    const menuData = response.data || [];

    // 查找移动端权限菜单
    const mobileMenu = menuData.find((menu) => menu.code === "mobile");

    if (!mobileMenu || !mobileMenu.children) {
      console.warn("未找到移动端权限菜单");
      return [];
    }

    // 扁平化移动端路由
    const mobileRoutes = flattenMobileRoutes(mobileMenu.children);

    // 过滤出有效的路由（有对应组件的）
    const validRoutes = mobileRoutes.filter(
      (route) => route.component !== null,
    );

    console.log("动态添加的移动端路由:", validRoutes);

    return validRoutes;
  } catch (error) {
    console.error("获取动态路由失败:", error);
    return [];
  }
}

// 获取移动端菜单列表（用于首页显示）
export async function getMobileMenuList() {
  try {
    const response = await fetchMenuRoutes();
    const menuData = response.data || [];

    // 查找移动端权限菜单
    const mobileMenu = menuData.find((menu) => menu.code === "mobile");

    if (!mobileMenu || !mobileMenu.children) {
      return [];
    }

    // 转换为首页需要的格式
    return mobileMenu.children.map((menu) => ({
      id: menu.id,
      code: menu.code,
      name: menu.name,
      alias: menu.alias,
      path: menu.path,
      icon: menu.source,
    }));
  } catch (error) {
    console.error("获取移动端菜单失败:", error);
    return [];
  }
}
